import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@/store/hooks';
import {
  selectChartType,
  selectDataTable,
  selectDimensions,
  selectedChartWidget,
  selectMetrics,
} from '@/features/dashboard/dashboardSlice';
import {
  getDataTableHeadingsForMetricsAndDimensions,
  validateDataTable,
} from '@/features/dashboard/utils';
import { TABLE } from '@/components/charting/chartType.constants';

export const useSwitchChartType_LEGACY = () => {
  const dispatch = useDispatch();
  const widgetKey = useAppSelector(selectedChartWidget)?.key;
  const chartType = useAppSelector(selectChartType);
  const metrics = useAppSelector(selectMetrics) ?? [];
  const dimensions = useAppSelector(selectDimensions) ?? [];
  const dataTable = useAppSelector(selectDataTable);

  React.useEffect(() => {
    let newConfigs;
    if (widgetKey !== undefined && dataTable) {
      const newHeadings = getDataTableHeadingsForMetricsAndDimensions(
        dataTable,
        [...dimensions, ...metrics],
      );
      const isValid = validateDataTable(newHeadings, chartType);
      if (chartType !== TABLE && isValid) {
        newConfigs = {
          chartType,
          metrics,
          dimensions,
        };
      }

      if (newConfigs) {
        dispatch({
          type: 'UPDATE_WIDGET_CHART_CONFIGS',
          payload: {
            widgetKey,
            ...newConfigs,
          },
        });
      }
    }
  }, [widgetKey, chartType, metrics, dimensions]);

  // const handleChangePresentation = (newChartType: TChartType) =>
  //   // TODO: refactor to a proper state and dispatch. The current logic works with the LEGACY state.
  //   dispatch({
  //     type: 'MODAL_INTERACTION',
  //     payload: {
  //       modalType: 'dashboards_view',
  //       props: {
  //         section: 'change-display-type',
  //         widgetIndex: widget?.key,
  //         newDisplayType: newChartType,
  //       },
  //     },
  //   });
  //
  // return handleChangePresentation;
};
